"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const input_1 = __importDefault(require("@kyruus/input"));
const styles_1 = require("../../../styles");
const label_1 = __importDefault(require("../../label"));
const use_validation_1 = __importDefault(require("../../../validation/use-validation"));
const use_form_1 = __importStar(require("../../../form/use-form"));
const validateEmail_1 = require("../../../validation/validators/validateEmail");
const read_only_1 = __importDefault(require("../../read-only"));
const EmailInput = ({ path, showLabel = true }) => {
    const { context: { breakpoints, isRequiredMarker, isNotRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    const emailRef = (0, react_1.useRef)();
    const confirmRef = (0, react_1.useRef)();
    let confirm = false;
    const [emailState, emailActions] = (0, use_form_1.default)(path, {
        eventProcessor: (event) => event.target.value,
        validator: (email) => {
            const isValid = (0, validateEmail_1.validateEmail)(email);
            // NOTE: `confirm` gets updated **after** `useForm` returns
            if (confirm) {
                return isValid && email === confirmRef.current.value;
            }
            return isValid;
        }
    });
    const config = emailState.config;
    confirm = config.confirm;
    const { value: confirmValue, onBlur: confirmOnBlur, onChange: confirmOnChange, errors: confirmErrors } = (0, use_validation_1.default)(Object.assign(Object.assign({}, confirm), { value: emailState.value, errors: [], consumerOnChange: () => 
        // re-run email validation on each confirm change
        emailActions.onChange({ target: { value: emailState.value } }), eventProcessor: (event) => event.target.value, validator: (email) => { var _a; return email === ((_a = emailRef.current) === null || _a === void 0 ? void 0 : _a.value); } }));
    const { AddOn } = emailState;
    if (!config.isVisible)
        return null;
    if (config.isReadOnly) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(label_1.default, { visuallyHidden: !showLabel, style: { marginLeft: '0' } }, config.label),
            react_1.default.createElement(read_only_1.default, { msg: emailState.value })));
    }
    const Wrapper = confirm ? styles_1.EmailWrapperWithConfirm : styles_1.EmailWrapper;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Wrapper, { breakpoints: breakpoints },
            react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: Boolean(emailState.errors.length) },
                react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: emailState.errors, style: { position: 'relative' } },
                    react_1.default.createElement(label_1.default, { visuallyHidden: !showLabel, isRequired: config.isRequired, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, style: { marginLeft: '0' } }, config.label),
                    react_1.default.createElement(input_1.default, Object.assign({}, config, { required: config.isRequired, errors: emailState.errors, ref: emailRef, name: path, path: path, "aria-label": config.label, id: path, hideLabel: true, onBlur: (event) => {
                            var _a;
                            const missingRequiredValue = emailState.config.isRequired && !event.target.value;
                            const hasConfirmValue = ((_a = confirmRef.current) === null || _a === void 0 ? void 0 : _a.value) || !confirm;
                            const shouldShowErrors = hasConfirmValue ||
                                missingRequiredValue ||
                                !(0, validateEmail_1.validateEmail)(event.target.value);
                            shouldShowErrors && emailActions.onBlur(event);
                        }, onChange: emailActions.onChange, value: emailState.value, "data-testid": path })))),
            confirm && (react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!confirmErrors.length },
                react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: confirmErrors, style: { position: 'relative' } },
                    react_1.default.createElement(label_1.default, { isRequired: config.isRequired, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, style: { marginLeft: '0' } }, confirm.label),
                    react_1.default.createElement(input_1.default, Object.assign({}, confirm, { ref: confirmRef, "aria-label": confirm.label, hideLabel: true, name: confirm.path, id: confirm.path, onBlur: (e) => {
                            confirmOnBlur(e);
                            emailActions.onBlur({ target: { value: emailState.value } });
                        }, value: confirmValue, onChange: confirmOnChange, type: confirm.type || config.type, "data-testid": confirm.path }))),
                confirmErrors.map((error, index) => (react_1.default.createElement(styles_1.ErrorMessage, { key: `${error}-${index}` }, error)))))),
        react_1.default.createElement(AddOn, null)));
};
EmailInput.propTypes = {
    /**
     * The unique identifier for the input within the form and the name
     */
    path: prop_types_1.default.string,
    showLabel: prop_types_1.default.bool
};
EmailInput.defaultProps = {
    path: 'email',
    showLabel: true
};
exports.default = EmailInput;
exports.defaultConfig = {
    placeholder: 'Email Address',
    autoComplete: 'email'
};
//# sourceMappingURL=index.js.map